import { apiSnop } from '@auteco/enviroment/apiSnop'
import { loaderService } from './loaderService'

const getToken =  () =>  JSON.parse(sessionStorage.getItem('userInfo')).token || null


const getRolUser = async () => {
  loaderService.show()
  try {
    const response = await apiSnop.get('/backend/roles/iam',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getEcualizador = async () => {
  try {
    const response = await apiSnop.get('backend/ecualizador',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
} 

const setEcualizador = async (params) => {
  try {
    const response = await apiSnop.post('backend/ecualizador', params, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const setEcualizadorPrev = async (params) => {
  try {
    const response = await apiSnop.post(
      'backend/ecualizador/preecualizar',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const setMaterialManual = async (params) => {
  try {
    const response = await apiSnop.post('backend/ecualizador/manual', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getConsolidadoMaterialInfo = async (materialId) => {
  loaderService.show()
  try {
    const response = await apiSnop.get(
      `backend/materiales/consolidado?material_id=${materialId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getComportamientoMaterial = async (materialId) => {
  loaderService.show()
  try {
    const response = await apiSnop.get(
      `backend/materiales/comportamiento?material_id=${materialId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getFilters = async () => {
  try {
    const response = await apiSnop.get('/backend/materiales/filtros', 
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postMaterials = async ({ params }) => {
  try {
    console.log('primary', params)
    const response = await apiSnop.post('/backend/materiales/filtrados', params, 
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getFiltersEcualizador = async () => {
  try {
    const response = await apiSnop.get('/backend/ecualizador/filtros',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getUsersToConfig = async () => {
  loaderService.show()
  try {
    const response = await apiSnop.get('/backend/roles/usuarios',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postRolUserConfig = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post('/backend/roles/usuarios', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const deleteRolUserConfig = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.delete(
      `/backend/roles/usuarios?usuario_id=${params.userId}&rol_id=${params.rolId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postMaterialsManager = async ({ params }) => {
  try {
    const response = await apiSnop.post(
      '/backend/materiales/calculo_fases',
      params, 
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postGraficaFiltrar = async ({ params }) => {
  try {
    const response = await apiSnop.post('/backend/grafica/filtrar', params, 
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postGraficaEventos = async ({ params }) => {
  try {
    const response = await apiSnop.post('/backend/grafica/eventos', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postModelosAplicacion = async ({ params }) => {
  try {
    const response = await apiSnop.post(
      `/backend/materiales/modelos_aplicacion`,
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getMaterialsManagerByIdMaterial = async (id) => {
  try {
    const response = await apiSnop.get(
      `/backend/materiales/calculo_fases?material=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getSynchronizationMaterials = async () => {
  loaderService.show()
  try {
    const response = await apiSnop.get(
      `backend/materiales/calculo_fases/sincronizacion`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getSynchronizationData = async () => {
  loaderService.show()
  try {
    const response = await apiSnop.get(`backend/drilldown`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postMaterialsEcualizador = async ({ params }) => {
  try {
    const response = await apiSnop.post('/backend/ecualizador/filtrar', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getOneGroup = async ({ id }) => {
  try {
    const response = await apiSnop.get(`/backend/grupos_materiales?id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getMaterialsNoGroup = async () => {
  try {
    const response = await apiSnop.get(`/backend/materiales/sin_grupo`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data.materiales
    }
    return false
  } catch (error) {
    return false
  }
}

const getMaterialsGroups = async () => {
  try {
    const response = await apiSnop.get('/backend/grupos',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postMaterialsGroups = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post('/backend/grupos', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const deleteMaterialGroup = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post(
      '/backend/grupos_materiales_desasociar_multiple',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const editGroup = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.put('/backend/grupos', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const deleteGroup = async ({ id }) => {
  loaderService.show()
  try {
    const response = await apiSnop.delete(`/backend/grupos?id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const assignMaterialsToGroup = async ({ params }) => {
  try {
    const response = await apiSnop.post(
      '/backend/grupos_materiales_asociar_multiple',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const assingMaterialsState = async ({ params }) => {
  try {
    const response = await apiSnop.put(
      '/backend/material/estado_multiple',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getProfiles = async () => {
  try {
    const response = await apiSnop.get('/backend/perfiles',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postProfile = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post('/backend/perfiles', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const editProfile = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.put('/backend/perfiles', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const deleteProfile = async ({ id }) => {
  loaderService.show()
  try {
    const response = await apiSnop.delete(`/backend/perfiles?id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const relateProfileWithUser = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post(
      '/backend/perfiles_usuarios_asociar',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const deleteUserFromProfile = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post(
      '/backend/perfiles_usuarios_desasociar',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const relateProfileWithGroup = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post(
      '/backend/perfiles_grupos_asociar',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const deleteGroupFromProfile = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post(
      '/backend/perfiles_grupos_desasociar',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getProgressBars = async () => {
  try {
    const response = await apiSnop.get('/backend/materiales/contar',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getUserProfiles = async () => {
  try {
    const response = await apiSnop.get('/backend/mis/perfiles',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getUserGroupsProfile = async ({ id }) => {
  try {
      const response = await apiSnop.get(`/backend/mis/grupos?perfil_id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getUserMaterialsGroup = async ({ id }) => {
  loaderService.show()
  try {
    const response = await apiSnop.get(`/backend/mis/materiales?grupo_id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }finally{
    loaderService.hide()
  }
}

const updateMaterialStatus = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.put('/backend/material/estado', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getUserMaterialsSummary = async ({ id }) => {
  loaderService.show()
  try {
    const response = await apiSnop.get(
      `/backend/materiales/obligatorios_estado_count?grupo_id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getEvents = async ({ id }) => {
  loaderService.show()
  try {
    const response = await apiSnop.get(`/backend/eventos?grupo_id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getEventsMaterial = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.get(
      `/backend/eventos?grupo_id=${params.id}&material=${params.material}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }   
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getgroupIdByMaterial = async (id) => {
  loaderService.show()
  try {
    const response = await apiSnop.get(
      `/backend/materiales/consultar_grupo?material_id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postEvent = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post('/backend/eventos', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )

    if (response.status === 200) {
      return response.data
    }
    if (response.status === 400) {
      console.log(response.data.error, '1')
      if (
        response.data.error ===
        "Duplicate entry 'remate baterias' for key 'eventos.eventos_unique"
      ) {
        return { error: 'Ya existe un evento con el mismo nombre' }
      }
    }
    return false
  } catch (error) {
    console.log(error.response.data.error, '2')

    if (
      error.response.data.error &&
      (error.response.data.error.includes("Duplicate"))
    ) {
      return { error: 'Ya existe un evento con el mismo nombre' }
    }
    // return { error: 'Error de conexión' }
  } finally {
    loaderService.hide()
  }
}

const putEvent = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.put('/backend/eventos', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const deleteEventByID = async ( id ) => {
  loaderService.show()
  try {
    const response = await apiSnop.delete(
      `/backend/eventos?evento_id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}


const deleteEvent = async ({ id, groupId }) => {
  loaderService.show()
  try {
    const response = await apiSnop.delete(
      `/backend/eventos?evento_id=${id}&grupo_id=${groupId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postMonthEvent = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.post('/backend/eventos/mes', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const editMonthEvent = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.put('/backend/eventos/meses', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postMonthEventNoGroup = async ({ params }) => {
  loaderService.show()
  try {
      const response = await apiSnop.post('/backend/eventos/mes_sin_grupo', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}


const deleteMonthEvent = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiSnop.delete(
      `/backend/eventos/mes?evento_id=${params.eventId}&ejecucion=${params.date}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getGeneralState = async () => {
  loaderService.show()
  try {
    const response = await apiSnop.get('/backend/estado',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postGeneralState = async (body) => {
  loaderService.show()
  try {
    const response = await apiSnop.put('/backend/estado', body,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postGroupMaterialState = async (body) => {
  loaderService.show()
  try {
    const response = await apiSnop.post('/backend/grupos/estado', body,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postGroupMaterialExport = async (idGrupo) => {
  loaderService.show()
  try {
    const response = await apiSnop.get(`/backend/grupos/exportar?id=${idGrupo}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getMaterialsList = async () => {
  loaderService.show()
  try {
    const response = await apiSnop.get('/backend/grupos_materiales_asociados',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getNotas = async () => {
  loaderService.show()
  try {
    const response = await apiSnop.get('/backend/bitacoras',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postNota= async (body) => {
  loaderService.show()
  try {
    const response = await apiSnop.post('/backend/bitacoras', body,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getDataByGroupId = async ({ id }) => {
  try {
    const response = await apiSnop.get(`/backend/grafica/medidas_ponderadas_grupo?grupo_id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}


const postMedidasPonderadas = async ({ params }) => {
  try {
    const response = await apiSnop.post('/backend/grafica/medidas_ponderadas', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postFiltrarTabla = async ({ params }) => {
  try {
    const response = await apiSnop.post('/backend/grafica/filtrar_tabla', params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const sendFile = async (body) => {
  const response = await apiSnop.post('/backend/baseline/manual', body,
    {
      headers: {
        Authorization: `${getToken()}`,
      },
    }
  )
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
    return false
  }
}

const getFile = async (idGrupo) => {
  loaderService.show()
    const response = await apiSnop.get(`/backend/archivo/proyeccion?grupo_id=${idGrupo}`,
    {
      headers: {
        Authorization: `${getToken()}`,
      },
    }
  )
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
  }finally{
    loaderService.hide()
  }
}

const resumenGrupo = async (idGrupo) => {
  const response = await apiSnop.get(`/backend/grafica/filtrar_tabla_grupo?grupo_id=${idGrupo}`,
    {
      headers: {
        Authorization: `${getToken()}`,
      },
    }
  )
  try {
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    console.log('Error get List ')
  }
}

const importGroupMaterials = async (file) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('archivo', file)
    
    const response = await apiSnop.post('/backend/grupos/importar', formData, {
      headers: {
        Authorization: `${getToken()}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    
    if (response.status === 200) {
      // Check if response is {"info":0} which indicates an error
      if (response.data && response.data.info === 0) {
        return { success: false, error: 'Error al importar el archivo' }
      }
      return { success: true, data: response.data }
    }
    return { success: false, error: 'Error al importar el archivo' }
  } catch (error) {
    return { success: false, error: error.response?.data?.message || 'Error al importar el archivo' }
  } finally {
    loaderService.hide()
  }
}


export {
  getRolUser,
  getUsersToConfig,
  postRolUserConfig,
  deleteRolUserConfig,
  postMaterials,
  getOneGroup,
  getMaterialsGroups,
  postMaterialsGroups,
  deleteMaterialGroup,
  editGroup,
  deleteGroup,
  assignMaterialsToGroup,
  getProfiles,
  postProfile,
  editProfile,
  deleteProfile,
  relateProfileWithGroup,
  deleteGroupFromProfile,
  relateProfileWithUser,
  deleteUserFromProfile,
  getProgressBars,
  getUserProfiles,
  getUserGroupsProfile,
  getUserMaterialsGroup,
  getUserMaterialsSummary,
  updateMaterialStatus,
  getEvents,
  getEventsMaterial,
  postEvent,
  putEvent,
  deleteEvent,
  postMonthEvent,
  deleteMonthEvent,
  getFilters,
  getConsolidadoMaterialInfo,
  getComportamientoMaterial,
  getMaterialsNoGroup,
  getEcualizador,
  getFiltersEcualizador,
  postMaterialsEcualizador,
  setEcualizador,
  setEcualizadorPrev,
  setMaterialManual,
  postMaterialsManager,
  postModelosAplicacion,
  getMaterialsManagerByIdMaterial,
  getgroupIdByMaterial,
  getSynchronizationData,
  getSynchronizationMaterials,
  getGeneralState,
  postGeneralState,
  postGraficaFiltrar,
  postGraficaEventos,
  getMaterialsList,
  getNotas,
  postNota,
  postMedidasPonderadas,
  postFiltrarTabla,
  postMonthEventNoGroup,
  deleteEventByID,
  postGroupMaterialState,
  getDataByGroupId,
  sendFile,
  getFile,
  assingMaterialsState,
  resumenGrupo,
  postGroupMaterialExport,
  editMonthEvent,
  importGroupMaterials
}
